import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';

import { LoadingPage } from 'pages/loading';
import { App } from './App';


ReactDOM.render(
	<React.StrictMode>
		<RecoilRoot>
			<Suspense fallback={<LoadingPage />}>
				<App />
			</Suspense>
		</RecoilRoot>
	</React.StrictMode>,
	document.getElementById('root')
);
